<template>
  <div id="invoice-rejection">
    <v-dialog v-model="isOpen" persistent max-width="500">
      <v-card class="align-center">
        <v-card-title>
          <div class="d-flex align-center justify-space-between w-100">
            <h1>Rejeitar Fatura</h1>
            <v-btn icon @click="close" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="mt-4 text-center">
          <v-row class="mt-5 d-flex justify-center mx-auto">
            <v-col cols="12">
              <v-textarea v-model="invoiceToReject.observation" label="Motivo da Rejeição"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex pb-4 px-5">
          <v-btn class="flex-grow-1" color="error" large @click="close"> Cancelar </v-btn>
          <v-btn
            class="flex-grow-1"
            color="success"
            large
            :disabled="!invoiceToReject.observation"
            :loading="isRejectButtonLoading"
            @click="rejectInvoice()"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MessagesError from '@/components/MessagesError.vue';

export default {
  props: {
    isOpen: {
      default: false,
      type: Boolean
    },
    idInvoice: null
  },
  components: {
    MessagesError
  },
  data: () => ({
    isRejectButtonLoading: false,
    invoiceToReject: {
      id: null,
      observation: null
    },
    errors: [],
    errorsType: 'error',
    error500: null
  }),

  watch: {
    isOpen: {
      async handler(isOpen) {
        if (isOpen) {
          this.invoiceToReject.id = this.idInvoice;
        }
      }
    }
  },

  methods: {
    ...mapActions('InvoicesReceivableStore', ['rejectInvoiceByShipper']),

    async rejectInvoice() {
      try {
        this.isRejectButtonLoading = true;

        const data = await this.rejectInvoiceByShipper(this.invoiceToReject);
        if (data.success) {
          this.handleSuccessFeedbackRejectInvoice();
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (e) {
        console.error(e);
        this.errors = ['Opss, algo deu errado!'];
        this.errorsType = 'error';
      } finally {
        this.isRejectButtonLoading = false;
        this.idInvoice = null;
        this.close();
      }
    },

    handleSuccessFeedbackRejectInvoice() {
      this.errors = ['Fatura rejeitada com sucesso!'];
      this.errorsType = 'success';
      this.isRejectDialogOpen = false;
      this.$emit('shouldUpdateList');
    },

    close() {
      this.$emit('update:isOpen', false);
    }
  }
};
</script>
